export const apiPath = '/v2/type_eligibilities';
const actionType = 'ELIGIBILITIES';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
